import React from "react";
import PageHero from "../components/PageHero";
import SectionHead from "../components/SectionHead";
import WorkflowSteps from "../components/WorkflowSteps";
import ApiFlowDiagram from "../components/ApiFlowDiagram";
import CtaBanner from "../components/CtaBanner";
import { WORKFLOW_STEPS } from "../data/content";

function HowItWorks() {
  return (
    <>
      <PageHero
        eyebrow="How it works"
        title="From launching the app to a completed HR request"
        subtitle="The MPeoples HRMS app provides a structured workflow that lets employees securely log in, record attendance, and manage HR activities end to end."
      />

      <section className="section">
        <div className="container">
          <WorkflowSteps steps={WORKFLOW_STEPS} />
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <SectionHead eyebrow="API communication" title="Every action follows the same request path" />
          <ApiFlowDiagram />
        </div>
      </section>

      <CtaBanner />
    </>
  );
}

export default HowItWorks;
